const WorkExperienceContractType = {
  Unknown: "UNKNOWN",
  Regular: "REGULAR",
  Contract: "CONTRACT",
  Dispatch: "DISPATCH",
  Intern: "INTERN",
  ShortTerm: "SHORT_TERM",
  Freelancer: "FREELANCER",
  Executive: "EXECUTIVE"
};

export { WorkExperienceContractType };
//# sourceMappingURL=work-experience-contract-type.mjs.map
